import { unified } from 'unified';
import remarkParse from 'remark-parse';
import { Text, View } from '@react-pdf/renderer';

const renderNode = (node, key) => {
    switch (node.type) {
        case 'paragraph':
            return (
                <Text key={key} style={{ marginBottom: 6, textAlign: 'justify', lineHeight: 1 }}>
                    {node.children.map((child, i) => renderNode(child, i))}
                </Text>
            );

        case 'strong':
            return (
                <Text key={key} style={{ fontWeight: 'bold' }}>
                    {node.children.map((child, i) => renderNode(child, i))}
                </Text>
            );

        case 'emphasis':
            return (
                <Text key={key} style={{ fontStyle: 'italic' }}>
                    {node.children.map((child, i) => renderNode(child, i))}
                </Text>
            );

        case 'list':
            return (
                <View key={key} style={{ marginBottom: 6, marginLeft: 12 }}>
                    {node.children.map((child, i) => renderNode(child, i))}
                </View>
            );

        case 'listItem':
            return (
                <Text key={key} style={{ textAlign: 'justify', lineHeight: 1 }}>
                    • {node.children.map((child, i) => renderNode(child, i))}{'\n'}
                </Text>
            );

        case 'heading':
            return (
                <Text
                    key={key}
                    style={{
                        fontSize: 14 + (6 - node.depth) * 1.5,
                        fontWeight: 'bold',
                        marginBottom: 6,
                        lineHeight: 1
                    }}
                >
                    {node.children.map((child, i) => renderNode(child, i))}
                </Text>
            );

        case 'text':
            return node.value;

        default:
            return null;
    }
};

export const markdownToReactPdf = (markdown) => {
    const tree = unified().use(remarkParse).parse(markdown);
    return tree.children.map((node, i) => renderNode(node, i));
};
